import { cn } from "@/shared/lib/cn";
import type { HTMLAttributes } from "react";
import { motion, type MotionProps } from "framer-motion";

export type VStackProps = HTMLAttributes<HTMLDivElement> & MotionProps;

export const VStack = ({ className, children, ...props }: VStackProps) => (
	<motion.div className={cn("flex flex-col justify-center items-center", className)} {...props}>
		{children}
	</motion.div>
);
